import { evaluate } from "mathjs"

export class Calculator {
    constructor(formula, variables) {
        this.formula = formula
        this.variables = variables
    }

    compute() {
        const variables = this.variables.reduce((vars, v) => {
            vars[v.name] = v.value
            return vars
        }, {})

        return this.formula.map((output) => {
            return [
                output[0],
                output[2] === "round"
                    ? Math.round(evaluate(output[1], variables))
                    : Math.round(evaluate(output[1], variables) * 10) / 10,
            ]
        })
    }
}

export class Input {
    constructor(name, selector) {
        this.name = name
        this.element = document.querySelector(selector)
    }

    get value() {
        if (this.element.type == "text") return Number(this.element.value)
        if (this.element.type == "checkbox") return Number(this.element.checked)
        if (this.element.type == "select-one") return this.element.value
    }
}

const VALIDATION_LOOKUP = {
    NUMBER: (value) => typeof value == Number,
    BOOLEAN: (value) => typeof value == Boolean,
    PROJECT_TYPE: (value) => value in PROJECT_TYPES,
}

const PROJECT_TYPES = [
    "Rafraichissement",
    "Rénovation Légère",
    "Rénovation Lourde",
    "Réhabilitation Lourde",
]

// const calculator = new Calculator([
//     {name:"construction_neuve", selector: "#construction_neuve", validations: ["NUMBER"]},
//     {name:"project_type", selector:"#project_type", validations:["PROJECT_TYPE"]},
//     {name:"piscine", selector:"#piscine", validations:["BOOLEAN"]}
// ], "construction_neuve * 10 + project_type * project_type_coefficient")
